exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".break-row[data-v-36dc8312]{white-space:pre-wrap;word-wrap:break-word}.disabled-link[data-v-36dc8312]{pointer-events:none;opacity:.65}@media (max-width:768px){.small-font[data-v-36dc8312]{font-size:80%;font-weight:400}}", ""]);

// exports
